import { CallToActionType } from "../api/Flyer";
import { validatePhoneNumber } from "./phoneNumber";
import { validateSMSUrlFormat } from "./sms";
import validateEmailFormat from "./validateEmail";
import validateUrlFormat from "./validateUrlFormat";

export function validateCTA(type: CallToActionType, value: string) {
  if (type === "call" && !validatePhoneNumber(value)) {
    return "Please enter a valid phone number";
  } else if (type === "email" && !validateEmailFormat(value)) {
    return "Please enter a valid e-mail";
  } else if (type === "sms") {
    return validateSMS(value);
  } else if (!isContactType(type) && !validateUrlFormat(value)) {
    return "Your URL should start with https:// or http://";
  }
}

// Contact links open an app on the device, so they skip the safe-URL check.
export function isContactType(type: CallToActionType) {
  return type === "call" || type === "email" || type === "sms";
}

// Name the part that is wrong: the scheme, the message, or the number.
function validateSMS(value: string) {
  if (validateSMSUrlFormat(value)) return;
  if (!/^sms(to)?:/i.test(value)) {
    return "SMS links start with sms:, like sms:+18669494386";
  }
  if (value.includes("?")) {
    return "Write the message as ?body=, like sms:+18669494386?body=Hello";
  }
  return "Enter a phone number after sms:, like sms:+18669494386";
}
